import { FC, useCallback, useEffect, useState } from 'react';
import { Image, ScrollView, StyleSheet, Text, View } from 'react-native';
import { MAX_WIDTH } from '../../constants/platform';
import MyAccountMenu from '../../components/MyAccountMenu/MyAccountMenu';
import PageTitle from '../../components/PageTitle';
import { COLORS, FONTS } from '../../constants';
import {
  IActivities,
  IActivity,
  IMyActivity,
} from '../../types/activities.types';
import MyActivityItem from './componentns/MyActivityItem';
import { Footer } from '../../components/Footer';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { AuthApi } from '../../services/api/auth.api';
import { Loading } from '../../components';
import { Button } from '../../components/Button';

const MyActivities: FC = () => {
  const isDesktop = useIsDesktop();

  const [activities, setActivities] = useState<IMyActivity[]>([]);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getMyActivities = useCallback(
    async (pageNumber: number) => {
      setIsLoading(true);
      AuthApi.getMyActivities({ page: pageNumber })
        .then((res) => {
          setActivities(res.data.data.data);
          setTotal(res.data.data.total);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [setIsLoading, setActivities, setTotal]
  );

  const handleLoadmore = useCallback(async () => {
    if (activities.length < total) {
      setPage(Math.ceil(activities.length / 10) + 1);
      AuthApi.getMyActivities({ page: Math.ceil(activities.length / 10) + 1 })
        .then((res) => {
          setActivities([...activities, ...res.data.data.data]);
          setTotal(res.data.data.total);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [total, activities]);

  useEffect(() => {
    setPage(1);
    setTotal(0);
    getMyActivities(1);
  }, [getMyActivities]);

  if (isDesktop()) {
    return (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View
          style={{
            maxWidth: MAX_WIDTH,
            width: '90%',
            marginHorizontal: 'auto',
            paddingTop: 40,
            marginBottom: 200,
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
            }}
          >
            <View style={{ width: '22%', minWidth: 230, marginRight: 20 }}>
              <MyAccountMenu />
            </View>
            <View style={{ width: '70%' }}>
              <PageTitle title="My Activities" haveGoBackButton={true} />
              <View
                style={{
                  paddingHorizontal: 40,
                  paddingTop: 40,
                  backgroundColor: COLORS.LIGHT_RED,
                  borderRadius: 18,
                  flexDirection: 'column',
                  shadowColor: '#F0F0F0',
                  shadowOffset: { width: 0, height: 12 },
                  shadowOpacity: 1,
                  shadowRadius: 32,
                  elevation: 20,
                }}
              >
                <View style={{ flexDirection: 'column' }}>
                  {activities &&
                    activities.map((item, index) => {
                      return (
                        <View
                          style={{
                            marginBottom: 30,
                          }}
                        >
                          <MyActivityItem item={item} />
                        </View>
                      );
                    })}
                </View>
                {isLoading === false && activities.length === 0 ? (
                  <View style={styles.noDataWrapper}>
                    <Text style={[styles.noDataText, { fontSize: 20 }]}>
                      THERE ARE CURRENTLY NO ACTIVITIES
                    </Text>
                  </View>
                ) : (
                  <></>
                )}
                {isLoading && <Loading style={{ paddingVertical: 30 }} />}
                {total > activities.length && (
                  <View
                    style={{
                      marginTop: 10,
                      marginBottom: 35,
                      alignSelf: 'center',
                    }}
                  >
                    <Button
                      text="VIEW MORE"
                      style={{
                        paddingHorizontal: 35,
                        paddingVertical: 12,
                      }}
                      onPress={handleLoadmore}
                      disabled={isLoading}
                      arrowRight={false}
                      textStyle={{
                        textTransform: 'uppercase',
                        fontFamily: FONTS.AvenirMedium,
                        fontWeight: '800',
                        fontSize: 15,
                      }}
                    />
                  </View>
                )}
              </View>
            </View>
          </View>
        </View>
        <Footer />
      </ScrollView>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <PageTitle title={'MY ACTIVITIES'} haveGoBackButton={true} />
      <View
        style={{
          paddingHorizontal: 40,
          paddingVertical: 40,
          backgroundColor: '#F9F1F1',
        }}
      >
        <View style={{ flexDirection: 'column' }}>
          {activities &&
            activities.map((item, index) => {
              return (
                <View
                  style={{
                    marginBottom: 30,
                  }}
                >
                  <MyActivityItem item={item} />
                </View>
              );
            })}
        </View>
        {isLoading === false && activities.length === 0 ? (
          <View style={styles.noDataWrapper}>
            <Text style={[styles.noDataText, { fontSize: 20 }]}>
              THERE ARE CURRENTLY NO ACTIVITIES
            </Text>
          </View>
        ) : (
          <></>
        )}
        {isLoading && <Loading style={{ paddingVertical: 30 }} />}
        {total > activities.length && (
          <View
            style={{
              marginTop: 10,
              marginBottom: 35,
              alignSelf: 'center',
            }}
          >
            <Button
              text="VIEW MORE"
              style={{
                paddingHorizontal: 35,
                paddingVertical: 12,
              }}
              onPress={handleLoadmore}
              disabled={isLoading}
              arrowRight={false}
              textStyle={{
                textTransform: 'uppercase',
                fontFamily: FONTS.AvenirMedium,
                fontWeight: '800',
                fontSize: 15,
              }}
            />
          </View>
        )}
      </View>
      <Footer />
    </ScrollView>
  );
};

export default MyActivities;

const styles = StyleSheet.create({
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: 20,
    width: '100%',
  },
  noDataText: {
    color: COLORS.BLACK,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirRegular,
    textAlign: 'center',
  },
});
